import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Spinner from '../UI/Spinner/Spinner'
import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'

export default function MobStoreRedirect() {
  const [loading, setLoading] = React.useState(true)
  const history = useHistory()
  const location = useLocation()
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  const getReturnTo = () => {
    const params = new URLSearchParams(location.search)
    const fromQuery = params.get('from')
    const fromState = location.state && location.state.from

    if (typeof fromQuery === 'string' && fromQuery.startsWith('/')) return fromQuery
    if (typeof fromState === 'string' && fromState.startsWith('/')) return fromState

    try {
      if (document.referrer) {
        const ref = new URL(document.referrer)
        if (ref.origin === window.location.origin) {
          return `${ref.pathname}${ref.search}${ref.hash}`
        }
      }
    } catch (e) {
      return '/'
    }

    return '/'
  }

  const redirectBack = () => {
    const returnTo = sessionStorage.getItem('mob_store_return_to') || '/'
    history.replace(returnTo)
  }

  useEffect(() => {
    sessionStorage.setItem('mob_store_return_to', getReturnTo())

    const isIos = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    const isAndroid = /android/i.test(userAgent)
    if (isIos) {
      window.location.assign('https://apps.apple.com/ua/app/nextship/id1554236157')
      setLoading(false)
    } else if (isAndroid) {
      window.location.assign('https://play.google.com/store/apps/details?id=com.nextship.client')
      setLoading(false)
    } else {
      setLoading(false)
      redirectBack()
    }
  }, [userAgent, history])

  useEffect(() => {
    if (!loading) {
      const t = window.setTimeout(() => {
        if (document.visibilityState === 'visible') {
          redirectBack()
        }
      }, 1500)

      return () => window.clearTimeout(t)
    }
  }, [loading])

  return (
    <div id='page' className='page'>
      <Header />
      <div>
        <div className='container'>{loading && <Spinner size={250} />}</div>
      </div>
      <Footer />
    </div>
  )
}
